import React, { type ReactNode } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { PACKAGE_NAME } from '../constants.tsx';
import { isPremium } from '../controllers/index.tsx';
import { BusinessIntroAnimation } from './business-intro-animation/index.tsx';
import { TryJWMSampleProjectView } from './try-jwm-sample-project-view/index.tsx';

export const JWMEmptyView = ({ children }: { children: ReactNode }) => {
	const { appEditions } = useTenantContext();
	const isPremiumEdition = isPremium(appEditions);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const analyticsEvent = createAnalyticsEvent({
		action: 'viewed',
		actionSubject: 'jwm empty view',
	});
	fireUIAnalytics(analyticsEvent, { isPremium: isPremiumEdition });

	return !isPremiumEdition ? (
		<TryJWMSampleProjectView>
			<BusinessIntroAnimation />
		</TryJWMSampleProjectView>
	) : (
		<>{children}</>
	);
};

export const JWMEmptyViewWithErrorBoundary = ({ children }: { children: ReactNode }) => (
	<JSErrorBoundary
		id="jira-business.sample-project.try-jwm-sample-project-view"
		packageName={PACKAGE_NAME}
		teamName="jira-werewolves"
		fallback="unmount"
	>
		<JWMEmptyView>{children}</JWMEmptyView>
	</JSErrorBoundary>
);
